export const environment = {
  api: 'https://cg-ipg-api.nt-development.dev',
  returnUrl: 'https://coinigo.com',
  copyRightDisplayYear: '2026',
  helpEmailAddress: 'help@coinigo.com',
};
